<template>
  <div
    id="opening-periods-section"
    class="mb-5 periods"
    v-if="hasField('OPENING_HOURS')"
    style="margin-bottom: 50px !important"
  >
    <div class="tabulation-title">
      <h5><v-icon class="blue--text text--darken-2">label</v-icon> Périodes et horaires d'ouverture</h5>
    </div>

    <div v-if="$route.path.includes('answer') && hasField('OPENING_HOURS') && provider.opening_periods.length === 0">
      <v-alert
        type="info"
        text
        class="mt-5 mb-5 form-container mr-auto ml-auto"
        border="right"
        colored-border
      >
        <p>Aucune période d'ouverture renseignée</p>
      </v-alert>
    </div>

    <div
      class="form-container mr-auto ml-auto mb-5 element tab-periods-container"
      v-for="(period, i) in provider.opening_periods"
      v-if="hasField('OPENING_HOURS')"
    >
      <!-- Tab title -->
      <div class="tab-periods-title-container mb-5">
        <div class="d-flex align-items-center tab-periods-title">
          <h6 class="mb-0">
            Du <b>{{ formatDate(period.valid_from, false) }}</b> au <b>{{ formatDate(period.valid_through, false) }}</b>
          </h6>
          <v-icon @click="openEditModal(period)">edit</v-icon>
        </div>
        <div>
          <v-tooltip
            slot="append-outer"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                color="red"
                @click="confirmDelete(i)"
                >delete</v-icon
              >
            </template>
            <span>Supprimer la période d'ouverture</span>
          </v-tooltip>
        </div>
      </div>

      <!-- Open 24/24 -->
      <div
        v-if="hasField('OPEN_24')"
        class="mb-5"
      >
        <v-checkbox
          v-model="period.h24"
          label="Ouvert 24h/24"
          hide-details
        >
        </v-checkbox>

        <div
          class="suggestion-container"
          style="width: auto !important"
          v-if="suggestedH24"
        >
          <div class="d-flex justify-content-between">
            <div>
              <b>Suggestion proposée - Ouvert 24h/24</b>
            </div>

            <div class="d-flex mb-auto ml-md-0 ml-5 mt-md-auto mt-3">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    color="success"
                    class="mr-3"
                    icon
                    v-on="on"
                    dark
                    @click="validH24Suggestion(period)"
                  >
                    <v-icon>check</v-icon>
                  </v-btn>
                </template>
                <div>Accepter</div>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    small
                    dark
                    icon
                    color="error"
                    @click="removeH24Suggestion"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
                <div>Refuser</div>
              </v-tooltip>
            </div>
          </div>

          <div class="mt-3">
            <div style="color: gray">
              <i>Information présente sur Google</i>
            </div>
            <div>Ouvert du lundi au dimanche 24h/24</div>
          </div>
        </div>
      </div>

      <!-- Tab content -->
      <div v-show="!period.h24">
        <div
          v-for="day in period.opening_days"
          :key="day.day_of_week"
          class="row opening-hour-raw"
        >
          <div class="col-1">
            <b>{{ daysOfWeek[day.day_of_week] }}</b>
          </div>
          <div class="col-2">
            <v-switch
              v-model="day.closed"
              :label="$data[day.closed ? 'closed' : 'open']"
              color="red"
              class="mt-0"
              @change="updateClosed(day, period)"
              :value="day.closed"
              hide-details
            >
            </v-switch>
          </div>
          <div class="col">
            <div
              class="mb-2"
              v-for="(hours, i) in day.opening_hours"
            >
              <div class="input-time">
                <div class="d-flex">
                  <div class="d-flex">
                    <div class="d-flex">
                      <div class="text-center m-auto prepend-hour">
                        <span class="mr-2 mt-auto mb-auto">de</span>
                      </div>
                      <el-time-select
                        v-model="hours.open"
                        placeholder="--:--"
                        :picker-options="{
                          step: '00:15',
                          start: '00:00',
                          end: '23:45',
                        }"
                        @change="updateTime($event, hours, 'open')"
                      >
                      </el-time-select>
                    </div>
                    <div class="d-flex">
                      <div class="text-center m-auto prepend-hour">
                        <span class="ml-2 mr-2 mt-auto mb-auto">à</span>
                      </div>
                      <el-time-select
                        v-model="hours.close"
                        :value="hours.close"
                        placeholder="--:--"
                        :picker-options="{
                          step: '00:15',
                          start: '00:00',
                          end: '23:45',
                          minTime: hours.open,
                        }"
                        @change="updateTime($event, hours, 'close')"
                      >
                      </el-time-select>
                    </div>
                  </div>
                  <div
                    style="width: 36px"
                    class="mt-auto mb-auto"
                  >
                    <v-tooltip
                      slot="append-outer"
                      bottom
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          color="error"
                          class="ml-2"
                          small
                          icon
                          v-on="on"
                          @click="deleteHours(day, i)"
                        >
                          <v-icon>clear</v-icon>
                        </v-btn>
                      </template>
                      <span>Supprimer la tranche horaire</span>
                    </v-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-1">
            <v-btn
              x-small
              fab
              color="primary"
              @click="addHours(day, period)"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Complément -->
      <div
        class="complement mt-10"
        v-if="hasField('COMPLEMENT_OUVERTURE')"
      >
        <v-textarea
          class="textarea"
          v-model="period.description"
          label="Complément d'horaires"
          height="150px !important"
          outlined
        >
        </v-textarea>
      </div>
    </div>

    <v-alert
      type="error"
      text
      v-if="provider.opening_periods.length === 0 && !disabled"
      class="mt-5 mb-5 form-container mr-auto ml-auto"
      border="right"
      colored-border
    >
      <p>
        Vous n'avez pas renseigné vos horaires d'ouverture. Il s'agit d'une information importante pour vos visiteurs.
      </p>
      <p>Nous vous suggérons de prendre quelques minutes pour bien renseigner vos horaires d'ouverture.</p>
    </v-alert>

    <div class="text-center mt-4">
      <v-btn
        color="primary"
        class="add-period-button"
        @click="clickAddPeriod"
      >
        <v-icon
          small
          class="mr-2"
          >add</v-icon
        >
        Ajouter une période d'ouverture
      </v-btn>
    </div>

    <confirm ref="confirm"></confirm>

    <v-dialog
      ref="dialog"
      v-model="showAddPeriodModal"
      persistent
      width="350px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Vous êtes ouvert</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="dateStartFr"
            label="Du"
            readonly
            @click="openPicker('dateStart')"
            outlined
          >
          </v-text-field>
          <v-text-field
            v-model="dateStopFr"
            label="Au"
            readonly
            @click="openPicker('dateStop')"
            outlined
          >
          </v-text-field>

          <v-alert
            type="error"
            v-if="message !== null"
          >
            {{ message }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="showAddPeriodModal = false"
            >Fermer</v-btn
          >
          <v-btn
            color="primary"
            :disabled="message !== null || dateStop === null || dateStart == null"
            @click="saveDate"
          >
            Ajouter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      ref="dialog"
      v-model="showEditPeriodModal"
      persistent
      width="290px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Modifier une période</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="dateStartFr"
            label="Date de début"
            readonly
            @click="openPicker('dateStart')"
            outlined
          >
          </v-text-field>
          <v-text-field
            v-model="dateStopFr"
            label="Date de fin"
            readonly
            @click="openPicker('dateStop')"
            outlined
          >
          </v-text-field>

          <v-alert
            type="error"
            v-if="message !== null"
          >
            {{ message }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="showEditPeriodModal = false"
            >Annuler</v-btn
          >
          <v-btn
            color="primary"
            :disabled="message !== null || dateStop === null || dateStart == null"
            @click="updatePeriod"
          >
            Modifier
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      ref="dialog"
      v-model="showPicker"
      persistent
      width="290px"
    >
      <v-date-picker
        locale="fr-FR"
        color="primary"
        v-model="selectedDate"
        @input="setDatePicker"
        :first-day-of-week="1"
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="showPicker = false"
          >Annuler</v-btn
        >
        <v-btn
          text
          color="primary"
          @click="showPicker = false"
          >Valider</v-btn
        >
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import Confirm from "../../tools/Confirm"
import { mapGetters, mapMutations, mapState } from "vuex"
import _ from "lodash"

export default {
  name: "OpeningHours",
  components: { Confirm },
  data() {
    return {
      showPicker: false,
      selectedPeriod: null,
      daysOfWeek: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
      selectedDate: null,
      selectedDateProperty: null,
      selectedDateDay: null,
      selectedDateHoursIndex: null,
      selectedDateHoursProperty: null,
      closed: "Fermé",
      open: "Ouvert",
      showAddPeriodModal: false,
      showEditPeriodModal: false,
      dateStart: null,
      dateStop: null,
      dateStartFr: null,
      dateStopFr: null,
      message: null,
    }
  },
  methods: {
    ...mapMutations("web_form", ["updateProvider", "setSuggestedH24"]),
    addPeriod() {
      let period = {
        description: null,
        valid_from: null,
        valid_through: null,
        opening_days: [
          { closed: true, day_of_week: 0 },
          { closed: true, day_of_week: 1 },
          { closed: true, day_of_week: 2 },
          { closed: true, day_of_week: 3 },
          { closed: true, day_of_week: 4 },
          { closed: true, day_of_week: 5 },
          { closed: true, day_of_week: 6 },
        ],
      }

      period.valid_from = this.dateStart
      period.valid_through = this.dateStop

      this.provider.opening_periods.push(period)
    },
    confirmDelete(index) {
      let period = this.provider.opening_periods[index]

      this.$refs.confirm
        .open(
          "Attention",
          "Vous allez supprimer les horaires saisies pour la période du " +
            this.formatDate(period.valid_from, false) +
            " au " +
            this.formatDate(period.valid_through, false) +
            ". " +
            "Êtes-vous sûr de vouloir supprimer cette période ?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            let index = this.provider.opening_periods.findIndex((_period) => _period === period)
            this.deletePeriod(index)
          }
        })
    },
    deletePeriod(index) {
      this.provider.opening_periods.splice(index, 1)

      this.$forceUpdate()
    },
    addHours(day, period) {
      let createNew = false

      if (day.opening_hours === undefined) {
        this.$set(day, "opening_hours", [])
      }

      if (!day.opening_hours.length) {
        let lastDayIndexWithHours = this.getLastDayIndexWithHours(day, period)

        if (lastDayIndexWithHours !== null) {
          let lastDay = period.opening_days[lastDayIndexWithHours]

          if (lastDay.opening_hours.length) {
            lastDay.opening_hours.forEach((range) => {
              let hour = {}

              this.$set(hour, "open", range.open)
              this.$set(hour, "close", range.close)

              day.opening_hours.push(hour)
            })
          }
        } else {
          createNew = true
        }
      } else {
        createNew = true
      }

      if (createNew) {
        let hours = {}

        this.$set(hours, "open", "")
        this.$set(hours, "close", "")

        day.opening_hours.push(hours)
      }

      day.closed = false

      this.$forceUpdate()
    },
    getLastDayIndexWithHours(day, period) {
      let median = null
      let i = null

      period.opening_days.forEach((_day, index) => {
        if (_day === day) {
          median = index
        }
      })

      period.opening_days.forEach((_day, index) => {
        if (index < median && _day.opening_hours !== undefined && _day.opening_hours.length) {
          i = index
        }
      })

      return i >= 0 ? i : null
    },
    deleteHours(day, index) {
      day.opening_hours.splice(index, 1)

      this.$forceUpdate()
    },
    updateClosed(day, period) {
      if (day.opening_hours === undefined) {
        this.$set(day, "opening_hours", [])
      }

      if (day.closed !== true && day.opening_hours.length === 0) {
        this.addHours(day, period)
      }

      if (day.closed) {
        day.opening_hours = []
      }

      this.$forceUpdate()
    },
    openPicker(property) {
      this.selectedDateProperty = property
      this.showPicker = true
    },
    updateTime(e, hour, property) {
      hour[property] = e
    },
    saveDate() {
      this.addPeriod()

      this.showAddPeriodModal = false
    },
    updatePeriod() {
      this.selectedPeriod.valid_from = this.dateStart
      this.selectedPeriod.valid_through = this.dateStop

      this.showEditPeriodModal = false
    },
    setDatePicker(value) {
      this[this.selectedDateProperty] = value
      this[this.selectedDateProperty + "Fr"] = this.formatDate(value, false)

      this.message = this.checkDateValidity()
    },
    checkDateValidity() {
      let message = null

      if (this.dateStart > this.dateStop) {
        message = "La date de début doit précéder la date de fin"
      }

      this.provider.opening_periods.forEach((period) => {
        if (
          period !== this.selectedPeriod &&
          ((this.dateStart >= period.valid_from && this.dateStart <= period.valid_through) ||
            (this.dateStop >= period.valid_from && this.dateStop <= period.valid_through))
        ) {
          message = "La période que vous créez actuellement recouvre une autre période"
        }
      })

      return message
    },
    openEditModal(period) {
      this.showEditPeriodModal = true
      this.selectedPeriod = period
      this.dateStart = this.selectedPeriod.valid_from
      this.dateStop = this.selectedPeriod.valid_through
      this.dateStartFr = this.formatDate(this.selectedPeriod.valid_from, false)
      this.dateStopFr = this.formatDate(this.selectedPeriod.valid_through, false)
    },
    clickAddPeriod() {
      this.selectedPeriod = null
      this.showAddPeriodModal = true

      this.dateStartFr = null
      this.dateStopFr = null
    },
    getSuggestionByDayIndex(index) {
      if (this.suggestedOpeningDays === undefined) {
        return null
      }

      let exist = this.suggestedOpeningDays.find((day) => day.day_of_week === index)

      return exist !== undefined ? exist : null
    },
    addSuggestion(dayOfWeek) {
      let hours = null

      this.suggestedOpeningDays.forEach((day) => {
        if (day.day_of_week === dayOfWeek) {
          hours = day.opening_hours
        }
      })

      this.provider.opening_periods[0].opening_days[dayOfWeek].closed = false
      this.provider.opening_periods[0].opening_days[dayOfWeek].opening_hours = JSON.parse(JSON.stringify(hours))

      this.suggestedOpeningDays.forEach((day, index) => {
        if (day.day_of_week === dayOfWeek) {
          this.suggestedOpeningDays.splice(index, 1)
        }
      })

      this.$forceUpdate()
    },
    removeSuggestion(dayOfWeek) {
      this.suggestedOpeningDays.forEach((suggestion, index) => {
        if (suggestion.day_of_week === dayOfWeek) {
          this.suggestedOpeningDays.splice(index, 1)
        }
      })
    },
    removeH24Suggestion() {
      this.setSuggestedH24(false)
    },
    validH24Suggestion(period) {
      period.h24 = true

      this.setSuggestedH24(false)
    },
  },
  computed: {
    ...mapState("web_form", ["provider", "disabled", "suggestedOpeningDays", "suggestedH24"]),
    ...mapGetters("web_form", ["hasField", "hasFamilyElement", "getFamilyByCode", "getElementsByFamilyCode"]),
  },
  watch: {
    provider: {
      handler: _.debounce(function () {
        this.updateProvider(this.provider)
      }, 200),
      deep: true,
    },
  },
  created() {
    this.provider.opening_periods.forEach((period) => {
      if (period.opening_days === undefined) {
        period.opening_days = [
          { closed: true, day_of_week: 0 },
          { closed: true, day_of_week: 1 },
          { closed: true, day_of_week: 2 },
          { closed: true, day_of_week: 3 },
          { closed: true, day_of_week: 4 },
          { closed: true, day_of_week: 5 },
          { closed: true, day_of_week: 6 },
        ]
      }

      period.opening_days.forEach((day) => {
        if (day.opening_hours === undefined) {
          this.$set(day, "opening_hours", [])
        }
      })

      this.loaded = true
    })
  },
}
</script>
